import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, lazy, Suspense } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import AutomationManualTriggersGlyph from './manaul-triggers-icon';
import Action from '../action';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { ActionName } from '../../../../../constants';
import { messages } from '../../../../../messages';
import { useSmartLinkContext } from '@atlaskit/link-provider';
var AutomationModal = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_smart-card-automation-modal" */'./automation-manual-triggers/manual-triggers-modal');
});
var handleAutomateActionClick = function handleAutomateActionClick(setIsModalOpen) {
  setIsModalOpen(true);
};
var handleAutomationActionClose = function handleAutomationActionClose(setIsModalOpen) {
  setIsModalOpen(false);
};
var AutomationAction = function AutomationAction(props) {
  var _ref, _context$actions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var smartLinkContext = useSmartLinkContext();
  var connections = smartLinkContext.connections;
  var environment = (_ref = connections.client.envKey) !== null && _ref !== void 0 ? _ref : 'prod';
  var context = useFlexibleUiContext();
  var automationActionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[ActionName.AutomationAction];
  if (!automationActionData) {
    return null;
  }
  var baseAutomationUrl = automationActionData.baseAutomationUrl,
    objectName = automationActionData.objectName,
    objectAri = automationActionData.objectAri,
    siteAri = automationActionData.siteAri,
    canManageAutomation = automationActionData.canManageAutomation,
    analyticsSource = automationActionData.analyticsSource,
    modalTitle = automationActionData.modalTitle,
    modalDescription = automationActionData.modalDescription;
  var automationActionTitle = /*#__PURE__*/React.createElement(FormattedMessage, messages.automation_action_title);
  var automationActionTooltip = /*#__PURE__*/React.createElement(FormattedMessage, messages.automation_action_tooltip);
  var automationActionIconLabel = formatMessage(messages.automation_action_icon_label);
  var automationModalTitle = /*#__PURE__*/React.createElement(FormattedMessage, modalTitle);
  var automationModalDescription = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, modalDescription, {
    values: {
      name: objectName,
      b: function b(chunks) {
        return /*#__PURE__*/React.createElement("strong", null, chunks);
      },
      br: /*#__PURE__*/React.createElement("br", null)
    }
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Action, _extends({
    content: automationActionTitle,
    icon: /*#__PURE__*/React.createElement(AutomationManualTriggersGlyph, {
      label: automationActionIconLabel
    }),
    testId: "smart-action-automation-action",
    tooltipMessage: automationActionTooltip
  }, automationActionData, props, {
    onClick: function onClick() {
      return handleAutomateActionClick(setIsModalOpen);
    }
  })), isModalOpen &&
  /*#__PURE__*/
  // TODO skeleton modal fallback
  React.createElement(Suspense, {
    fallback: false
  }, /*#__PURE__*/React.createElement(AutomationModal, {
    environment: environment,
    baseAutomationUrl: baseAutomationUrl,
    objectAri: objectAri,
    siteAri: siteAri,
    canManageAutomation: canManageAutomation,
    analyticsSource: analyticsSource,
    modalTitle: automationModalTitle,
    modalDescription: automationModalDescription,
    onClose: function onClose() {
      return handleAutomationActionClose(setIsModalOpen);
    }
  })));
};
export default AutomationAction;